import React, { useState } from "react";
import pica from "pica";

export default function ImageResizer() {
  const [outputUrl, setOutputUrl] = useState<string | null>(null);
  const [originalFileName, setOriginalFileName] = useState<string | null>(null);

  const handleFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setOriginalFileName(file.name);

    const img = new Image();
    img.src = URL.createObjectURL(file);
    await img.decode();

    const canvas = document.createElement("canvas");
    const ratio = img.width / img.height;

    canvas.width = 120 * ratio; // largeur auto
    canvas.height = 120;

    const p = pica();

    const result = await p.resize(img, canvas, {
      quality: 3,
      alpha: true
    });

    const mimeType = file.type === "image/png" ? "image/png" : "image/jpeg";
    const blob = await p.toBlob(result, mimeType, 1);
    setOutputUrl(URL.createObjectURL(blob));
  };

  const handleDownload = () => {
    if (!outputUrl || !originalFileName) return;

    // Ajouter "_resized" avant l'extension
    const dotIndex = originalFileName.lastIndexOf(".");
    const name = dotIndex !== -1 ? originalFileName.slice(0, dotIndex) : originalFileName;
    const ext = dotIndex !== -1 ? originalFileName.slice(dotIndex) : "";
    const resizedName = `${name}_resized${ext}`;

    const a = document.createElement("a");
    a.href = outputUrl;
    a.download = resizedName;
    a.click();
  };

  return (
    <div>
      <input
        type="file"
        accept="image/png, image/jpeg, image/jpg"
        onChange={handleFile}
      />

      {outputUrl && (
        <div style={{ marginTop: 10 }}>
          <img src={outputUrl} alt="resized" style={{ border: "1px solid #333" }} />
          <br />
          <button onClick={handleDownload} style={{ marginTop: 5 }}>
            Télécharger l'image
          </button>
        </div>
      )}
    </div>
  );
}
